// 数值格式化：超过1亿用B、1百万用M、1千用K
function numFormatter(value) {
    if (value >= 100000000) {
        return value / 100000000 + " B";
    } else if (value >= 1000000) {
        return value / 1000000 + " M";
    } else if (value >= 1000) {
        return value / 1000 + " K";
    }
    return value;
}

// 仅 WCI 时的布局：2 个 grid（WCI上 / WCI下）
export var WCIOptions = {
    Grid: [
        // 0: WCI 上图（堆叠面积）
        { left: 150, right: "5%", top: 60, height: "45%" },
        // 1: WCI 下图（单条曲线）
        { left: 150, right: "5%", top: "55%", height: "20%" },
    ],
    xAxis: [
        // 0: WCI 上图 x 轴
        {
            type: "category",
            gridIndex: 0,
            boundaryGap: false,
            data: [],
            axisLabel: { show: false },
        },
        // 1: WCI 下图 x 轴
        {
            type: "category",
            gridIndex: 1,
            data: [],
            boundaryGap: false,
            axisLine: { onZero: false },
            axisTick: { show: false },
            splitLine: { show: false },
            axisLabel: { show: false },
        },
    ],
    yAxis: [
        // 0: WCI 上图 y 轴
        {
            type: "value",
            gridIndex: 0,
            axisLabel: { formatter: numFormatter },
        },
        // 1: WCI 下图 y 轴
        {
            scale: true,
            gridIndex: 1,
            splitNumber: 2,
            type: "value",
            axisLabel: { show: false },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
        },
    ],
};

// 同时有 WCI 和 TK 时的布局：4 个 grid
export var WCITKOptions = {
    Grid: [
        // 0: WCI 上图（堆叠面积）
        { left: 150, right: "5%", top: 60, height: "32%" },
        // 1: WCI 下图（单条曲线）
        { left: 150, right: "5%", top: "38%", height: "10%" },
        // 2: TK 上图（堆叠面积）
        { left: 150, right: "5%", top: "50%", height: "32%" },
        // 3: TK 下图（单条曲线）
        { left: 150, right: "5%", top: "82%", height: "12%" },
    ],
    xAxis: [
        // 0: WCI 上图 x 轴
        {
            type: "category",
            gridIndex: 0,
            boundaryGap: false,
            data: [],
            axisLabel: { show: false },
        },
        // 1: WCI 下图 x 轴
        {
            type: "category",
            gridIndex: 1,
            data: [],
            boundaryGap: false,
            axisLine: { onZero: false },
            axisTick: { show: false },
            splitLine: { show: false },
            axisLabel: { show: false },
        },
        // 2: TK 上图 x 轴
        {
            type: "category",
            boundaryGap: false,
            data: [],
            gridIndex: 2,
            axisLabel: { show: false },
        },
        // 3: TK 下图 x 轴
        {
            type: "category",
            gridIndex: 3,
            data: [],
            boundaryGap: false,
            axisLine: { onZero: false },
            axisTick: { show: false },
            splitLine: { show: false },
            axisLabel: { show: false },
        },
    ],
    yAxis: [
        // 0: WCI 上图 y 轴
        {
            type: "value",
            gridIndex: 0,
            axisLabel: { formatter: numFormatter },
        },
        // 1: WCI 下图 y 轴
        {
            scale: true,
            gridIndex: 1,
            splitNumber: 2,
            type: "value",
            axisLabel: { show: false },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
        },
        // 2: TK 上图 y 轴
        {
            type: "value",
            gridIndex: 2,
            axisLabel: { formatter: numFormatter },
        },
        // 3: TK 下图 y 轴
        {
            scale: true,
            gridIndex: 3,
            splitNumber: 2,
            type: "value",
            axisLabel: { show: false },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
        },
    ],
};
